module.exports = __webpack_public_path__ + "img/img04.10010f4f.png";